import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import { filterCatalog } from "../../../../utils/exercise-catalog";
import SelectedExercises from "./SelectedExercises";
import CatalogList from "./CatalogList";
import CatalogSelectors from "./CatalogSelectors";
import SvgIcon from "../../../../parts/SvgIcon";
import MobileCatalogSelectors from "./MobileCatalogSelectors";
import { useRillContext } from "../../../../rill/RillReact/share/base";

const ExerciseCatalog = (props) => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const { exerciseCatalog } = locals;
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("Biceps");
  const initialState = {
    squat: [],
    bench: [],
    deadlift: [],
    assistant: [],
    clean: [],
    jerk: [],
    snatch: [],
    overheadPress: [],
    other: [],
  };
  const [selectedExercises, setSelectedExercises] = useState(initialState);

  const filteredExercises = useMemo(() => {
    return filterCatalog(exerciseCatalog, filter, search);
  }, [exerciseCatalog, filter, search]);

  const handleSelect = (exercise) => {
    const { primary } = exercise;
    setSelectedExercises((prevState) => {
      return { ...prevState, [primary]: [...prevState[primary], exercise] };
    });
  };

  const handleDeselect = (exercise) => {
    const { _id, primary } = exercise;
    setSelectedExercises((prevState) => {
      return {
        ...prevState,
        [primary]: prevState[primary].filter((ex) => ex._id !== _id),
      };
    });
  };
  const deselectAll = () => {
    setSelectedExercises(initialState);
  };

  const handleSave = (e) => {
    e.preventDefault();
    submit("/actions/user/catalog-add-exercises", {
      method: "POST",
      body: { selectedExercises },
    });
  };

  const isDisableButtonForMobile = () => {
    const {
      squat,
      bench,
      deadlift,
      assistant,
      clean,
      jerk,
      snatch,
      overheadPress,
      other,
    } = selectedExercises;

    const invalid =
      !squat.length &&
      !bench.length &&
      !deadlift.length &&
      !assistant.length &&
      !clean.length &&
      !jerk.length &&
      !snatch.length &&
      !overheadPress.length &&
      !other.length;

    return invalid;
  };

  return (
    <>
      {/* DESKTOP VERSION */}
      <section className="catalog-container mobile-hidden">
        <ExerciseCatalogHeader />
        <article>
          <CatalogSelectors
            onSelectorClick={setFilter}
            filter={filter}
            selectedExercises={selectedExercises}
          />
          <CatalogList
            filter={filter}
            filteredExercises={filteredExercises}
            selectedExercises={selectedExercises}
            handleDeselect={handleDeselect}
            handleSelect={handleSelect}
            search={search}
            onChangeFn={(e) => setSearch(e.target.value)}
          />
        </article>
      </section>
      <SelectedExercises
        selectedExercises={selectedExercises}
        handleDeselect={handleDeselect}
        deselectAll={deselectAll}
        classNames="mobile-hidden"
      />
      {/* MOBILE VERSION */}
      <section className="catalog-mobile-container only-show-mobile">
        <ExerciseCatalogHeader />
        <div className="catalog-mobile-data">
          <input
            type="search"
            className="text-input search-exercise"
            name="search"
            placeholder={t("exerciseLibraryCatalog.searchPlaceholder")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoComplete="off"
          />
          <MobileCatalogSelectors
            onSelectorClick={setFilter}
            filter={filter}
            selectedExercises={selectedExercises}
          />
          <CatalogList
            filter={filter}
            filteredExercises={filteredExercises}
            selectedExercises={selectedExercises}
            handleDeselect={handleDeselect}
            handleSelect={handleSelect}
            search={search}
            onChangeFn={(e) => setSearch(e.target.value)}
          />
        </div>
        <button
          data-button-type="primary"
          disabled={isDisableButtonForMobile() ? true : undefined}
          onClick={handleSave}
        >
          {t("exerciseLibraryCatalog.save")}
        </button>
      </section>
    </>
  );
};

export default ExerciseCatalog;

const ExerciseCatalogHeader = () => {
  const { t } = useTranslation("coaching-portal");
  return (
    <header>
      <a href="/coaching-portal/exercise-library">
        <SvgIcon
          src="/img/new-icons/back-button.svg"
          alt={t("exerciseLibraryCatalog.backArrow")}
        />
      </a>
      <hgroup>
        <h3>{t("exerciseLibraryCatalog.catalog")}</h3>
        <p className="p4">{t("exerciseLibraryCatalog.catalogDescription")}</p>
      </hgroup>
    </header>
  );
};
